const english = [
  {
    word: 'Hlavni mesto Praha',
    trans: 'Prague',
  },
  {
    word: 'Munchen-Flughafen',
    trans: 'Munich',
  },
  {
    word: 'Praha',
    trans: 'Prague',
  },
  {
    word: 'New Paris',
    trans: 'Paris',
  },
  {
    word: 'Schwechat',
    trans: 'Vienna',
  },
  {
    word: 'Muenchen',
    trans: 'Munich',
  },
  {
    word: 'Munchen',
    trans: 'Munich',
  },
  {
    word: 'Mnchen',
    trans: 'Munich',
  },
  {
    word: 'Nurnberg',
    trans: 'Nuremberg',
  },
  {
    word: 'New Town, Czechia',
    trans: 'Prague, Czechia',
  },
  {
    word: 'Old Town, Czechia',
    trans: 'Prague, Czechia',
  },
  {
    word: 'Mala Strana, Czechia',
    trans: 'Prague, Czechia',
  },
  {
    word: 'Vinohrady, Czechia',
    trans: 'Prague, Czechia',
  },
  {
    word: 'Wien',
    trans: 'Vienna',
  },
  {
    word: 'Brno-mesto',
    trans: 'Brno',
  },
  {
    word: 'Ostrava-mesto',
    trans: 'Ostrava',
  },
];

export default english;
